<template>
  <div>
    <div class="md-layout-item md-medium-size-100 md-size-100" :class="$attrs.targetClass">
      <md-card>
        <md-card-content>
          <div class="file-content">
            <md-field class="sel-mapping">
              <label>Mapping</label>
              <md-select v-model="mapping" @md-selected="mappingSelected">
                <md-option value="customForecast">
                  Custom Forecast
                </md-option>
                <md-option value="customBudget">
                  Custon Presupuesto
                </md-option>
                <md-option value="norayOwner">
                  Noray Owner
                </md-option>
                <md-option value="custom">
                  Custom
                </md-option>
                <md-option value="channel">
                  Channels
                </md-option>
                <md-option value="guarantee">
                  Guarantee
                </md-option>
                <md-option value="rateCode">
                  Rate Code
                </md-option>
                <md-option value="mapping">
                  Channels Manager Maping
                </md-option>
              </md-select>
            </md-field>
            <md-field v-if="showChannelsManager === true" class="sel-mapping">
              <label>Channel Manager</label>
              <md-select v-model="channelManager" @md-selected="channelManagerSelected">
                <md-option v-for="channelManager in channelManagerList" :key="channelManager.id" :value="channelManager.id">
                  {{ channelManager.id }}
                </md-option>
              </md-select>
            </md-field>

            <md-field>
              <label>Fichero</label>
              <md-file ref="file" v-model="single" accept=".xlsx" validaty="false" @md-change="fileSelected" />
            </md-field>
          </div>
        </md-card-content>
        <md-card-actions>
          <md-button class="md-success" :disabled="disabledExport" @click="exportFile">
            Exportar
          </md-button>
          <md-button class="md-success" :disabled="disabledImport" @click="importFile">
            Importar
          </md-button>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import ApiClient from '@/openapi/src/ApiClient'
import ChannelManagerApi from '@/openapi/src/api/ChannelManagerApi'
import Swal from 'sweetalert2'

const apiClient = ApiClient.instance

const channelsManagerApi = new ChannelManagerApi()

function callBack(url, token, filename) {
  fetch(url, {
    method: 'GET',
    headers: new Headers({
      Authorization: 'Bearer ' + token,
      accept: 'application/octet-stream',
    }),
  })
    .then((response) => {
      return response.blob()
    })
    .then((blob) => {
      var url = window.URL.createObjectURL(blob)
      var a = document.createElement('a')
      a.href = url
      a.download = filename
      document.body.appendChild(a) // we need to append the element to the dom -> otherwise it will not work in firefox
      a.click()
      a.remove() //afterwards we remove the element again
    })
    .catch((error) => ('Error al descargar el fichero', error))
}

export default {
  data() {
    return {
      mapping: null,
      channelManager: null,
      single: null,
      disabledExport: true,
      disabledImport: true,
      fileList: null,
      channelManagerList: null,
      showChannelsManager: false,
    }
  },
  methods: {
    enableImport() {
      if (
        (this.mapping && this.mapping !== 'mapping' && !!this.fileList) ||
        (this.mapping && this.mapping === 'mapping' && !!this.fileList && !!this.channelManager)
      ) {
        this.disabledImport = false
      } else {
        this.disabledImport = true
      }
    },
    mappingSelected() {
      if (!!this.mapping) {
        this.disabledExport = false
      } else {
        this.disabledExport = true
      }

      if (this.mapping === 'mapping') {
        this.showChannelsManager = true
      } else {
        this.showChannelsManager = false
        this.channelManager = null
      }

      this.enableImport()
    },

    channelManagerSelected(channelManager) {
      this.channelManager = channelManager
      this.enableImport()
    },

    fileSelected(fileList) {
      this.fileList = fileList
      this.enableImport()
    },
    exportFile() {
      let url
      let auth = apiClient.authentications['bearer-token']
      let token = typeof auth.accessToken === 'function' ? auth.accessToken() : auth.accessToken

      switch (this.mapping) {
        case 'customForecast':
          url = apiClient.buildUrl(
            '/custom-forecast/{hotelId}/excel',
            {
              hotelId: this.$root.hotelId,
            },
            null
          )

          callBack(url, token, `customForecastFromHotel${this.$root.hotelId}.xlsx`)

          //con openapi no funciona
          // customForecatApi.getCustomForecastByHotelId(this.$root.hotelId, (error, data) => {
          //   var blob = new Blob([new Uint8Array(data)], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
          //   var url = window.URL.createObjectURL(blob)
          //   var a = document.createElement('a')
          //   a.href = url
          //   a.download = 'filename.xlsx'
          //   document.body.appendChild(a) // we need to append the element to the dom -> otherwise it will not work in firefox
          //   a.click()
          //   a.remove() //afterwards we remove the element again
          // })

          break
        case 'customBudget':
          url = apiClient.buildUrl(
            '/custom-budget/{hotelId}/excel',
            {
              hotelId: this.$root.hotelId,
            },
            null
          )
          callBack(url, token, `customBudgetFromHotel${this.$root.hotelId}.xlsx`)

          break
        case 'norayOwner':
          url = apiClient.buildUrl(
            '/noray_owner/{hotelId}/excel',
            {
              hotelId: this.$root.hotelId,
            },
            null
          )
          callBack(url, token, `norayOwnerFromHotel${this.$root.hotelId}.xlsx`)

          break
        case 'custom':
          url = apiClient.buildUrl(
            '/custom/{hotelId}/excel',
            {
              hotelId: this.$root.hotelId,
            },
            null
          )
          callBack(url, token, `customHotel${this.$root.hotelId}.xlsx`)

          break
        case 'channel':
          url = apiClient.buildUrl(
            '/channel/{hotelId}/excel',
            {
              hotelId: this.$root.hotelId,
            },
            null
          )

          callBack(url, token, `channelsFromHotel${this.$root.hotelId}.xlsx`)

          break
        case 'guarantee':
          url = apiClient.buildUrl(
            '/guarantee/{hotelId}/excel',
            {
              hotelId: this.$root.hotelId,
            },
            null
          )

          callBack(url, token, `guaranteeFromHotel${this.$root.hotelId}.xlsx`)

          break
        case 'rateCode':
          url = apiClient.buildUrl(
            '/rate-code/{hotelId}/excel',
            {
              hotelId: this.$root.hotelId,
            },
            null
          )
          callBack(url, token, `rateCodeFromHotel${this.$root.hotelId}.xlsx`)

          break
        case 'mapping':
          url = apiClient.buildUrl(
            '/channel-manager-map/{hotelId}/{channelManagerId}/excel',
            {
              hotelId: this.$root.hotelId,
              channelManagerId: this.channelManager,
            },
            null
          )
          callBack(
            url,
            token,
            `${this.channelManager.charAt(0)}${this.channelManager.slice(1).toLowerCase()}MapFromHotel${this.$root.hotelId}.xlsx`
          )

          break
      }
    },
    importFile() {
      let url
      let auth = apiClient.authentications['bearer-token']
      let token = typeof auth.accessToken === 'function' ? auth.accessToken() : auth.accessToken

      const formData = new FormData()
      formData.append('excel', this.fileList[0])

      switch (this.mapping) {
        case 'customForecast':
          url = apiClient.buildUrl(
            '/custom-forecast/{hotelId}/excel',
            {
              hotelId: this.$root.hotelId,
            },
            null
          )
          break
        case 'customBudget':
          url = apiClient.buildUrl(
            '/custom-budget/{hotelId}/excel',
            {
              hotelId: this.$root.hotelId,
            },
            null
          )
          break
        case 'norayOwner':
          url = apiClient.buildUrl(
            '/noray_owner/{hotelId}/excel',
            {
              hotelId: this.$root.hotelId,
            },
            null
          )
          break
        case 'custom':
          url = apiClient.buildUrl(
            '/custom/{hotelId}/excel',
            {
              hotelId: this.$root.hotelId,
            },
            null
          )
          break
        case 'channel':
          url = apiClient.buildUrl(
            '/channel/{hotelId}/excel',
            {
              hotelId: this.$root.hotelId,
            },
            null
          )
          break
        case 'guarantee':
          url = apiClient.buildUrl(
            '/guarantee/{hotelId}/excel',
            {
              hotelId: this.$root.hotelId,
            },
            null
          )

          break
        case 'rateCode':
          url = apiClient.buildUrl(
            '/rate-code/{hotelId}/excel',
            {
              hotelId: this.$root.hotelId,
            },
            null
          )

          break
        case 'mapping':
          url = apiClient.buildUrl(
            '/channel-manager-map/{hotelId}/{channelManagerId}/excel',
            {
              hotelId: this.$root.hotelId,
              channelManagerId: this.channelManager,
            },
            null
          )
          break
      }

      fetch(url, {
        method: 'PUT',
        headers: new Headers({
          Authorization: 'Bearer ' + token,
          ContentType: 'multipart/form-data',
        }),
        body: formData,
      })
        .then(() => {
          this.mapping = null
          this.fileList = null
          this.single = null
          this.mappingSelected()
          this.fileSelected(this.fileList)
          this.$refs.file.clearField()
          this.$refs.file.$refs.inputFile.value = null
          Swal.fire({
            icon: 'success',
            title: 'The changes has been saved',
            showConfirmButton: false,
            timer: 2000,
          })
        })
        .catch((error) => ('Error al enviar y procesar el fichero', error))
    },
  },
  mounted() {
    channelsManagerApi.getChannelManagers(this.$root.hotelId, (error, channelManagerList) => {
      this.channelManagerList = channelManagerList.filter((element) => element.id !== 'OFFLINE' && element.id !== 'DUMMY')
    })
  },
}
</script>
<style lang="scss">
.file-content {
  display: flex;
  flex-direction: row;
  gap: 12px;
  .sel-mapping {
    max-width: 280px;
  }
}
</style>
